import { render } from "./OverviewPage.vue?vue&type=template&id=10beb936&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"

import "./OverviewPage.vue?vue&type=style&index=0&id=10beb936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10beb936"]])

export default __exports__